export default function allValuesAreTruthy(data: Record<string, unknown>) {
  if (!data) return false
  return Object.values(data ?? {}).every(Boolean)
}